import { render, staticRenderFns } from "./AcceptTRModal.vue?vue&type=template&id=76bdd0b6"
import script from "./acceptTRModal.ts?vue&type=script&lang=ts&external"
export * from "./acceptTRModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports